// ADR-0666: Ritual Pause and Reveal Timing
// Orchestrates intentional pacing for meaningful moments.

export interface RitualOptions {
  pause?: 'short' | 'medium' | 'long';
  stagger?: boolean;
  onSettle?: () => void;
}

const PAUSE_MS = { short: 300, medium: 600, long: 1000 };

export function revealRitual(container: HTMLElement, opts: RitualOptions = {}): void {
  const pause = PAUSE_MS[opts.pause ?? 'short'];
  const items = container.querySelectorAll('.ritual-pending');

  // Check reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(el => {
      el.classList.remove('ritual-pending');
      el.classList.add('ritual-reveal');
    });
    opts.onSettle?.();
    return;
  }

  setTimeout(() => {
    items.forEach((el) => {
      el.classList.add('ritual-reveal');
    });

    // Settle callback after all reveals complete
    const totalDuration = pause + 400 + (items.length * 120);
    setTimeout(() => {
      container.classList.add('ritual-settled');
      opts.onSettle?.();
    }, totalDuration);
  }, pause);
}

export function milestoneEmphasis(el: HTMLElement): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  el.classList.add('ritual-milestone');
  el.addEventListener('animationend', () => el.classList.remove('ritual-milestone'), { once: true });
}

// Auto-init: any element with data-ritual="reveal" triggers on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLElement>('[data-ritual="reveal"]').forEach(container => {
    const pause = (container.dataset.ritualPause as RitualOptions['pause']) ?? 'short';
    revealRitual(container, { pause });
  });
});
